import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { Note } from "../../types/types";
import { SingleNote } from "../../views/notes-view/components/SingleNote";
import styles from "./NotesArea.module.css";

interface Props {
    notes: Note[];
    error: any;
    loading: boolean;
    onNoteSaved(): void;
}
export function NotesArea({ notes, error, loading, onNoteSaved }: Props) {
    const { path } = useRouteMatch();
    return (
        <div className={ styles.container }>
            { loading
                ? <h1>Loading...</h1>
                : error 
                    ? <h1>Error: { error.message }</h1>
                    : (
                        <Switch>
                            <Route path={`${path}/create`}>
                                <SingleNote notes={notes} onNoteSaved={ onNoteSaved } />
                            </Route>
                            <Route path={`${path}/:noteId`}>
                                <SingleNote notes={notes} onNoteSaved={ onNoteSaved } />
                            </Route>
                            <Route path={`${path}/`}>
                                <div style={{ padding: 16 }}>
                                    <h1 style={{ margin: 0 }}>Please select a note or create a new one</h1>
                                </div>
                            </Route>
                        </Switch>
                    ) 
            }
        </div>
    )
}